export default __webpack_public_path__ + "static/gradient-4708a1729a8f4b0f7e53d8f7595a639a.svg";